import ButtonDefault from 'ui/src/buttons/ButtonDefault'
import ModalDefault from '@/components/parts/modal/ModalDefault'
import TableModalPaperEdit from '@/components/partsGroups/tables/TableModalPaperEdit'

interface Props {
  className?: string
  isOpen?: boolean
  data?: Paper
  onClose?: () => void
  saveAction?: (data: Paper) => void
}

export default function ModalPaperEdit({
  className,
  isOpen = false,
  data,
  onClose,
  saveAction,
}: Props) {
  return (
    <ModalDefault isOpen={isOpen} onClose={onClose}>
      <TableModalPaperEdit isOpen={isOpen} data={data} onClose={onClose} saveAction={saveAction} />
    </ModalDefault>
  )
}
